import {
  EXPIRED,
  TODAY,
  TOMORROW,
  UPCOMING,
} from '@app/pages/TasksList/constants/registryFilterTypes';

export const FILTER_TYPES = [
  {
    title: 'Просроченные',
    value: EXPIRED,
  },
  {
    title: 'На сегодня',
    value: TODAY,
  },
  {
    title: 'На завтра',
    value: TOMORROW,
  },
  {
    title: 'Предстоящие',
    value: UPCOMING,
  },
];
